











	import Vue from 'vue';

    export default Vue.extend({
        name: "MenuItemComp",
        props: ['menuItem'],
    })
